export const LANGUAGE_STORAGE_KEY = 'befront-admin-language';

export const SUPPORTED_LANGUAGES = ['en', 'ru'] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'ru';

export const normalizeLanguage = (language?: string | null): SupportedLanguage =>
  language?.startsWith('ru') ? 'ru' : 'en';
